import script from "./MultiWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiWallet.vue?vue&type=script&setup=true&lang=js"

import "./MultiWallet.vue?vue&type=style&index=0&id=048ba452&lang=css"

const __exports__ = script;

export default __exports__